var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityLogDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.518,
    height: 7.385,
    viewBox: "0 0 13.518 7.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(1.411 1.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M0,0,2.593,2.281,5.186,4.563",
    transform: "translate(0)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M5.512,0,0,4.563",
    transform: "translate(5.186 0)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogDropdown);
export default __webpack_public_path__ + "static/media/ActivityLogDropdown.ef9adc6b52fb8eb3915f269746ea1a0e.svg";
export { ForwardRef as ReactComponent };